import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { IconSeat, Paragraph } from "@trainline/depot-web";
import { SeatClass } from "../../types/SeatReservation";
import * as s from "./SeatReservations.module.css";
const AtocSeatReservations = ({ seatReservations, intl }) => {
  const seatGroupedByCarriage = seatReservations.reduce((acc, seatReservation) => {
    var _a;
    const id = (_a = seatReservation == null ? void 0 : seatReservation.compartment) == null ? void 0 : _a.identifier;
    if (!id) {
      return acc;
    }
    if (!acc[id]) {
      acc[id] = [];
    }
    acc[id].push(seatReservation);
    return acc;
  }, {});
  const summaryText = Object.keys(seatGroupedByCarriage).sort().map((carriage) => {
    const seats = seatGroupedByCarriage[carriage].map((seat) => {
      var _a;
      return `${seat.seatNumber ? seat.seatNumber : "No assigned seat"}${seat.seatingOptions ? ` (${(_a = seat.seatingOptions) == null ? void 0 : _a.trim()})` : ""}`;
    }).join(", ");
    return intl.formatMessage({
      id: "seatReservation.atocCarriage"
    }, { carriage, seats });
  }).join(" \u2022 ");
  return /* @__PURE__ */ React.createElement("section", {
    className: s.container
  }, /* @__PURE__ */ React.createElement("div", {
    className: s.icon
  }, /* @__PURE__ */ React.createElement(IconSeat, null)), /* @__PURE__ */ React.createElement("div", {
    className: s.summary
  }, seatReservations[0].originStation && /* @__PURE__ */ React.createElement(Paragraph, {
    fontWeight: "semibold"
  }, /* @__PURE__ */ React.createElement(FormattedMessage, {
    id: "seatReservation.travellingTo",
    values: {
      origin: seatReservations[0].originStation,
      destination: seatReservations[0].destinationStation
    }
  })), intl.formatMessage({
    id: seatReservations[0].seatClass === SeatClass.STANDARD ? "seatReservation.standardClass" : "seatReservation.firstClass"
  }), " ", "\u2022 ", summaryText));
};
var AtocSeatReservations_default = injectIntl(AtocSeatReservations);
export {
  AtocSeatReservations_default as default
};
